export const environment = {
  production: false,
  baseUrl: 'https://dev.luqta.io',
  paymentRedirectApi: '',
  apiUrl: 'https://xi5f-5y62-kbyr.n7e.xano.io/api',
  apiSuffix: ':test',
  dataSource: 'dev',
  Ai_insight_apiUrl: 'https://ai.luqta.io',
  // chatboltApiUrl: 'https://backend-api-chatbolt-backend.hf.space',
  chatboltApiUrl: 'https://xtroedge-chatbolt-dev.hf.space',
  googleMapsApiKey: '',
  appVersion: '5-12-2026-v1',
  firebaseConfig: {
    apiKey: "AIzaSyC2CTC9Yut75v2lptj8YGXQkWmKxf4d6to",
    authDomain: "luqta-50841.firebaseapp.com",
    projectId: "luqta-50841",
    storageBucket: "luqta-50841.firebasestorage.app",
    messagingSenderId: "104176712263",
    appId: "1:104176712263:web:1bb54a2e6b57608f268f62",
    measurementId: "G-J6M382CML7"
  }
};




// FOR LIVE
// ng build --configuration=production    live
// node scripts/version.js; ng build --configuration=development   dev
// FOR DEV
// ng build
// ng serve
// For version update node scripts/version.js; ng build --configuration=development
// Production chat bolt https://xtro-edge-chatbolt-backend.hf.space
// Dev chat bolt https://backend-api-chatbolt-backend.hf.space
// Procuction chat bolt admin https://admin-ai-agent-pro.vercel.app/app/dashboard/activity
// Dev chat bolt admin https://data-chat-agent-ai-pro.vercel.app/app/agents

